'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@material-bank/graphql-client';
import { useAuthProvider } from '@material-bank/mtag-authentication';
import { useCallback } from 'react';
import { GET_CURRENT_USER } from '../graphql/currentUser';
import type { UserProfile } from '../lib/user.types';
type CurrentUserQueryData = {
  currentUser: UserProfile | null;
};
type UseCurrentUserResult = {
  user: UserProfile | null;
  isLoading: boolean;
  refetchUser: () => Promise<UserProfile | null>;
};
export function useCurrentUser() {
  const $ = _c(8);
  const {
    status
  } = useAuthProvider();
  const t0 = status !== "authenticated";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      skip: t0,
      fetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: false
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    loading,
    refetch
  } = useQuery(GET_CURRENT_USER, t1);
  let t2;
  if ($[2] !== refetch) {
    t2 = async () => {
      const result = await refetch();
      return result.data?.currentUser ?? null;
    };
    $[2] = refetch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const refetchUser = t2;
  const t3 = data?.currentUser ?? null;
  let t4;
  if ($[4] !== loading || $[5] !== refetchUser || $[6] !== t3) {
    t4 = {
      user: t3,
      isLoading: loading,
      refetchUser
    };
    $[4] = loading;
    $[5] = refetchUser;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}